import { render } from "./Currency.vue?vue&type=template&id=2e366f92"
import script from "./Currency.vue?vue&type=script&lang=js"
export * from "./Currency.vue?vue&type=script&lang=js"
script.render = render

export default script